"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticChannelItems = exports.isMutingMessage = exports.isMuteMessageFromOtherUser = exports.isMessageFromMutedUser = exports.isBanningMessage = exports.getSinglePatientNameByNickName = exports.getChannelIdFromPath = exports.formatChatSeparatorDateTitle = exports.CHAT_COMMANDS = void 0;
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lodash = require("lodash");
var _StaticChannelLayouts = require("../components/StaticChannelLayouts");
var _utils = require("../../../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var isMessageFromMutedUser = function isMessageFromMutedUser(message, mutes) {
  return !!(0, _lodash.find)(mutes, function (mute) {
    return mute.target.id === message.user.id && (0, _momentTimezone.default)(mute.created_at).isBefore((0, _momentTimezone.default)(message.created_at));
  });
};
exports.isMessageFromMutedUser = isMessageFromMutedUser;
var isMuteMessageFromOtherUser = function isMuteMessageFromOtherUser(message, user) {
  return isMutingMessage(message.command) && message.user.id !== user.id;
};
exports.isMuteMessageFromOtherUser = isMuteMessageFromOtherUser;
var isMutingMessage = function isMutingMessage(command) {
  return [CHAT_COMMANDS.MUTE, CHAT_COMMANDS.UNMUTE].includes(command);
};
exports.isMutingMessage = isMutingMessage;
var isBanningMessage = function isBanningMessage(command) {
  return [CHAT_COMMANDS.BAN, CHAT_COMMANDS.UNBAN].includes(command);
};
exports.isBanningMessage = isBanningMessage;
var getChannelIdFromPath = function getChannelIdFromPath(baseUrl, pathname) {
  return pathname !== baseUrl ? pathname.replace("".concat(baseUrl, "/"), '') : null;
};
exports.getChannelIdFromPath = getChannelIdFromPath;
var getSinglePatientNameByNickName = function getSinglePatientNameByNickName(name, patients) {
  var patient = (0, _lodash.find)(patients, function (patient) {
    return patient.nickName === name;
  });
  var patientHasRealName = !(0, _lodash.isEmpty)(patient === null || patient === void 0 ? void 0 : patient.firstName) && !(0, _lodash.isEmpty)(patient === null || patient === void 0 ? void 0 : patient.lastName);
  if (patient && patientHasRealName) {
    name = "".concat(patient.firstName, " ").concat(patient.lastName);
    return name;
  }
};

// These are the channels with static layout, displayed same for all apps
exports.getSinglePatientNameByNickName = getSinglePatientNameByNickName;
var staticChannelItems = [{
  id: 'community_welcome_page',
  type: _utils.COMMUNITY_CHANNEL_TYPES.GETTING_STARTED,
  name: 'Welcome',
  component: _StaticChannelLayouts.WelcomeStaticLayout
}, {
  id: 'support_group_introductions_page',
  type: _utils.SUPPORT_GROUP_CHANNEL_TYPES.PUBLIC,
  name: 'Support groups introductions',
  component: _StaticChannelLayouts.SupportGroupIntroStaticLayout
}];
exports.staticChannelItems = staticChannelItems;
var CHAT_COMMANDS = {
  MUTE: 'mute',
  UNMUTE: 'unmute',
  BAN: 'ban',
  UNBAN: 'unban'
};
exports.CHAT_COMMANDS = CHAT_COMMANDS;
var formatChatSeparatorDateTitle = function formatChatSeparatorDateTitle(date) {
  return (0, _momentTimezone.default)(date).format(_utils.DEFAULT_CHAT_SEPARATOR_DATE_TITLE_FORMAT);
};
exports.formatChatSeparatorDateTitle = formatChatSeparatorDateTitle;